import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';
import Anchor from '../Anchor';
import Grid from '../Grid';
import Column from '../Column';
import List from '../List';
import ListItem from '../ListItem';
import Row from '../Row';
import Theme from '../../theme';
var SCAnchorBlack = styled(Anchor).withConfig({
  displayName: "DesktopMenu__SCAnchorBlack",
  componentId: "sc-pen39c-0"
})(["color:", ";font-size:", ";display:block;&:not([disabled]){&:hover{color:", ";}}& svg{float:right;}"], function (props) {
  return props.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
}, Theme.fonts.sizes.small, function (props) {
  return props.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
});
var SCAnchorBlackPrimary = styled(SCAnchorBlack).withConfig({
  displayName: "DesktopMenu__SCAnchorBlackPrimary",
  componentId: "sc-pen39c-1"
})(["display:block;line-height:", ";padding:0 0 0 ", ";font-size:", ";position:relative;transition:all 0.3s ease;cursor:", ";color:", ";&:not([disabled]):hover{color:", ";}"], remCalc(64), remCalc(20), Theme.fonts.sizes.regular, function (p) {
  return p.href ? 'pointer' : 'default';
}, function (p) {
  return p.active ? p.theme === 'dark' ? Theme.colours.white : Theme.colours.singtelred : p.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
}, function (p) {
  return p.active ? p.theme === 'dark' ? Theme.colours.white : Theme.colours.singtelred : p.theme === 'dark' ? Theme.colours.white : Theme.colours.black;
});
var SecondaryDesktop = styled.div.withConfig({
  displayName: "DesktopMenu__SecondaryDesktop",
  componentId: "sc-pen39c-2"
})(["width:100%;background-color:", " !important;box-shadow:1px 2px 10px 1px ", ";position:absolute;left:0;right:0;margin:0 auto;z-index:99999;"], function (props) {
  return props.theme === 'dark' ? Theme.colours.darkslate : Theme.colours.white;
}, Theme.colours.grey_d6);
var SCSecondaryMenuDesktopColumn = styled(Column).withConfig({
  displayName: "DesktopMenu__SCSecondaryMenuDesktopColumn",
  componentId: "sc-pen39c-3"
})(["padding:", ";padding-left:", ";border-right:1px solid ", ";"], remCalc(30), function (p) {
  return p.index === 0 ? remCalc(10) : remCalc(30);
}, Theme.colours.grey_e2);
var DesktopMenu = function DesktopMenu(_ref) {
  var baseUrl = _ref.baseUrl,
    menuItems = _ref.menuItems,
    menuHoverKey = _ref.menuHoverKey,
    onMenuMouseEnter = _ref.onMenuMouseEnter,
    onMenuMouseLeave = _ref.onMenuMouseLeave,
    theme = _ref.theme;
  return menuItems.map(function (menuItem, key) {
    var showSecondaryMenu = menuHoverKey === key && menuItem.subMenu && menuItem.subMenu.length > 0;
    return /*#__PURE__*/React.createElement(ListItem, {
      key: key,
      onMouseEnter: function onMouseEnter() {
        return onMenuMouseEnter(key);
      },
      onMouseLeave: function onMouseLeave() {
        return onMenuMouseLeave(key);
      }
    }, /*#__PURE__*/React.createElement(SCAnchorBlackPrimary, {
      active: menuItem.item.active,
      href: "" + baseUrl + menuItem.item.href,
      theme: theme
    }, menuItem.item.title), showSecondaryMenu && /*#__PURE__*/React.createElement(SecondaryDesktop, {
      theme: theme,
      "data-testid": "SecondaryDesktop"
    }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Row, null, (menuItem.subMenu || []).map(function (subMenuItem, key) {
      return /*#__PURE__*/React.createElement(SCSecondaryMenuDesktopColumn, {
        sm: true,
        key: key,
        index: key,
        "data-testid": "SCSecondaryMenuDesktopColumn"
      }, /*#__PURE__*/React.createElement(SCAnchorBlack, {
        href: "" + baseUrl + subMenuItem.item.href,
        theme: theme
      }, subMenuItem.item.title), /*#__PURE__*/React.createElement(List, {
        noPadding: true,
        showBullets: false
      }, (subMenuItem.subMenu || []).map(function (subSubMenuItem, key) {
        return /*#__PURE__*/React.createElement(ListItem, {
          key: key
        }, /*#__PURE__*/React.createElement(SCAnchorBlack, {
          secondary: true,
          href: "" + baseUrl + subSubMenuItem.item.href,
          theme: theme
        }, subSubMenuItem.item.title));
      })));
    })))));
  });
};
export default DesktopMenu;